import { render, staticRenderFns } from "./FavoriteApps.vue?vue&type=template&id=a06837b8&"
import script from "./FavoriteApps.vue?vue&type=script&lang=js&"
export * from "./FavoriteApps.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteApps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports